import { ThemeProvider } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import { BrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import themeContext from "./context/theme/ThemeContext";
import toastContext from "./context/toast/ToastContext";
import Toast from "./components/Toast_v2/Toast";
import TopLoader from "./components/TopLoadingBar/TopLoader";
import userContext from "./context/users/UserContext";
import { isMobile } from "react-device-detect";
import { registerIcons } from "@fluentui/react";
import SortMobileIcon from "./components/SVGComponents/SortMobileIcon";
import { RouterConfig } from "./config/RouterConfig";
import MobileNavbar from "./components/navbar/MobileNavbar";
import TopLoaderAnnotation from "./components/TopLoadingBar/TopLoaderAnnotation";
import ShareStudyIcon from "./components/SVGComponents/StudyList/Actions/ShareStudyIcon";
import TATIcon from "./components/SVGComponents/StudyList/Actions/TATIcon";
import UploadHistoryIcon from "./components/SVGComponents/StudyList/Actions/UploadHistoryIcon";
import DeleteCustomIcon from "./components/SVGComponents/StudyList/Actions/DeleteCustomIcon";
import ReinferenceIcon from "./components/SVGComponents/StudyList/Actions/ReinferenceIcon";
import ReturnStudyIcon from "./components/SVGComponents/StudyList/Actions/ReturnStudyIcon";
import MailIcon from "./components/SVGComponents/StudyList/Actions/MailIcon";
import CloseStudyIcon from "./components/SVGComponents/StudyList/Actions/CloseStudyIcon";
import AddToLibraryIcon from "./components/SVGComponents/StudyList/Actions/AddToLibraryIcon";
import ReportingIcon from "./components/SVGComponents/StudyList/Actions/ReportingIcon";
import RevertCloseStudyIcon from "./components/SVGComponents/StudyList/Actions/RevertCloseStudyIcon";
import PreviewStudyListIcon from "./components/SVGComponents/StudyList/Actions/PreviewStudyListIcon";
import DownloadReportIcon from "./components/SVGComponents/StudyList/Actions/DownloadReportIcon";
import RemoveFromLibraryIcon from "./components/SVGComponents/StudyList/Actions/RemoveFromLibraryIcon";
import ReportHistoryIcon from "./components/SVGComponents/StudyList/Actions/ReportHistoryIcon";
import EditPatientIcon from "./components/SVGComponents/StudyList/Actions/EditPatientIcon";
import ActionDownArrowIcon from "./components/SVGComponents/ActionDownArrowIcon";
import UploadedHistoryIcon from "./components/SVGComponents/StudyList/Actions/UploadedHistoryIcon";
import MoreIcon from "./components/SVGComponents/MoreIcon";
import LabelsIcon from "./components/SVGComponents/LabelsIcon";
import UnSendMailIcon from "./components/SVGComponents/StudyList/Actions/UnSendMailIcon";
import { AuthRoutes, MODAL_TYPE, NonAuthRoutes } from "./constants/Constants";
import GlobalModal from "./components/GlobalModal/GlobalModal";
import { useState } from "react";
import loaderContext from "./context/loader/LoaderContext";
import TourGuide from "./pages/AccountAndSettings/TourGuide/TourGuide";
import MobileBottomBar from "./components/navbar/MobileBottomBar";
import NotAllowed from "./components/NotAllowed";
import PeerReviewAssignmentIcon from "./components/SVGComponents/StudyList/Actions/PeerReviewAssignmentIcon";
import PeerReviewEvaluatorIcon from "./components/SVGComponents/StudyList/Actions/PeerReviewEvaluatorIcon";
import PeerReviewTimeLine from "./components/SVGComponents/StudyList/Actions/PeerReviewTimeLine";
import { getEnv } from './helpers/EnvHelper';

const Router = () => {
  const { theme, themeName } = useContext(themeContext);
  const { roles, username, loadByUsername, authenticated, contextSwitchUser ,unautherizedAccessObj} =
    useContext(userContext);
  const { showModal, setShowModal } = useContext(loaderContext);
  const [triedAuthenticating, setTriedAuthenticating] = useState(false);

  const desktopStyles = {
    height: "100%",
  };

  const noProbeRoutes = new Set([
    NonAuthRoutes.ROOT,
    NonAuthRoutes.LOGIN,
    NonAuthRoutes.FORGOTPASSWORD,
    NonAuthRoutes.ENTEROTP,
    NonAuthRoutes.RESETPASSWORD,
    NonAuthRoutes.TWOFACTORAUTHENTICATION,
    AuthRoutes.PRIVACY_POLICY,
  ]);

  const handleAuthentication = async () => {

    if (!authenticated) {
      if (noProbeRoutes.has(window.location.pathname)) {
        setTriedAuthenticating(true);
        return;
      }
      const res = await loadByUsername();
      if (!res) {
        if (
          AuthRoutes.PRIVACY_POLICY === window.location.pathname ||
          AuthRoutes.SHOW_SHARED_REPORT === window.location.pathname ||
          AuthRoutes.SHAREDVIEWER === window.location.pathname ||
          NonAuthRoutes.CONTEXTSWITCHSTUDYLIST === window.location.pathname ||
          NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname ||
          NonAuthRoutes.TWOFACTORAUTHENTICATION === window.location.pathname ||
          window.location.pathname.startsWith("/internal/datadump")
        ) {
          console.log("inside authentications");
          setTriedAuthenticating(true);
          return;
        }
        Object.values(AuthRoutes).map((path) => {
          if (path === window.location.pathname) {
            //To avoid infinite loop of redirects
            localStorage.removeItem("forceReset");
            localStorage.removeItem("redirectOnLogin");

            window.location.assign("/");
            return;
          }
        });
      }
      setTriedAuthenticating(true);
    } else {
      Object.values(NonAuthRoutes).map((path) => {
        if (path === window.location.pathname) {
          window.location.assign(AuthRoutes.STUDYLIST);
          return;
        }
      });
    }
  };

  useEffect(() => {
    if(!authenticated)
       handleAuthentication();
    else{
      setTriedAuthenticating(true);
    }
  }, [authenticated]);

  useEffect(() => {
    registerIcons({
      icons: {
        sortIcon: <SortMobileIcon />,
        studyListShareStudy: <ShareStudyIcon />,
        TATIcon: <TATIcon />,
        PeerReviewEvaluatorIcon:<PeerReviewEvaluatorIcon/>,
        PeerReviewAssignmentIcon:<PeerReviewAssignmentIcon/>,
        PeerReviewTimeLine:<PeerReviewTimeLine/>, 
        UploadHistoryIcon: <UploadHistoryIcon />,
        UploadedHistoryIcon: <UploadedHistoryIcon />,
        DeleteCustomIcon: <DeleteCustomIcon />,
        ReinferenceIcon: <ReinferenceIcon />,
        ReturnStudyIcon: <ReturnStudyIcon />,
        MailIcon: <MailIcon />,
        UnSendMailIcon: <UnSendMailIcon />,
        CloseStudyIcon: <CloseStudyIcon />,
        AddToLibraryIcon: <AddToLibraryIcon />,
        RemoveFromLibraryIcon: <RemoveFromLibraryIcon />,
        ReportingIcon: <ReportingIcon />,
        RevertCloseStudyIcon: <RevertCloseStudyIcon />,
        PreviewStudyListIcon: <PreviewStudyListIcon />,
        DownloadReportIcon: <DownloadReportIcon />,
        ReportHistoryIcon: <ReportHistoryIcon />,
        EditPatientIcon: <EditPatientIcon />,
        ActionDownArrowIcon: <ActionDownArrowIcon />,
        MoreCustomIcon: <MoreIcon />,
        LabelsIcon: <LabelsIcon />,
      },
    });
  }, []);

  const mobileStyles = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  };
  const { list, setList, progressList, setProgressList } =
    useContext(toastContext);

  return (
    <>
      {triedAuthenticating && (
        <div
          data-theme={
            // !window.location.pathname.includes("study/load") ?
            themeName
            //: "dark"
          }
          style={{
            height: "100%",
            width: "100%",
            position: isMobile ? "fixed" : "",
            //background: window.location.pathname.includes("study/load")
            //</>? "#000000"
            //: "",
          }}
        >
          <ThemeProvider
            style={isMobile ? mobileStyles : desktopStyles}
            applyTo="body"
            theme={theme}
            className={`app-root ${themeName}`}
          >
            <Toast
              toastList={list}
              setList={setList}
              progressList={progressList}
              setProgressList={setProgressList}
            />
            {showModal.show && showModal.type != null && (
              <GlobalModal showModal={showModal} />
            )}
            {showModal.show &&
              showModal.type != null &&
              showModal.type == MODAL_TYPE.TOUR && <TourGuide />}
            {/* {
          laoderRunning && */}
            <TopLoader />
            {/* <TopLoaderAnnotation /> */}
            {/* } */}
            {/* {!isMobile ? ( */}
            {/* <Navbar> */}
            {/* <RouterProvider router={RouterConfig}></RouterProvider> */}
            {/* </Navbar> */}
            {/* ) : ( */}
            {/* <MobileNavbar> */}
            {/* <RouterProvider router={RouterConfig}></RouterProvider> */}
            {/* </MobileNavbar> */}
            {/* )} */}

            {(!contextSwitchUser && (getEnv("REACT_APP_HYBRID_MODE") == "false" || isMobile) && window.location.pathname !== NonAuthRoutes.NEWREPORTWIDGET && (!window.location.pathname.startsWith("/internal/datadump") || authenticated)) ? (
              <>
              <Navbar />
              <MobileBottomBar /></>
            ) : (
              contextSwitchUser && unautherizedAccessObj.showError ? <NotAllowed msg={unautherizedAccessObj.errorMsg} />:
              <RouterProvider router={RouterConfig}></RouterProvider>
            )}
          </ThemeProvider>
        </div>
      )}
    </>
  );
};

export default Router;
